var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-select',{staticClass:"lang-widget",class:{ filled: _vm.filled },attrs:{"options":_vm.options,"size":"sm"},on:{"change":_vm.onLangChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }